import { HttpClient } from '../../httpClient'
import { OpalApi } from '../../schema'

type CreateResponseV2 = OpalApi<'CreateResponseV2', 201>

export const createResponse: CreateResponseV2 = async (args = {}) => {
  const url = new URL('/workflows/v2/responses', window.location.origin)

  return HttpClient()
    .post(url.toString(), args.requestBody)
    .then((res) => res.data)
}
